<app-logout-layout>
  <div class="content register-company-page">
    <div class="container">
      <div class="row mt-3">
        <div class="col-4 text-center">
          <img class="img-responsive w-75 pt-5" src="https://i.ibb.co/pPkvxpN/machango-triste-1.png" alt="formacion">
        </div>
        <div class="col-6 ml-auto mr-auto">
          <app-generic-panel
            [title]="errorTitle"
            [description]="''"
            [isAnimate]="true"
          >
          {{errorDescription}}
          <button
                class="btn btn-fill btn-sm btn-primary float-right mt-3"
                (click)="toLogin()"
                *ngIf="showButton"
              >
                {{textButton}}
              </button>
        </app-generic-panel>
        </div>
      </div>
    </div>
  </div>
</app-logout-layout>
